import React, { FC, useState } from 'react';
import Calender from 'assets/svg/calendar-icon.svg';

import { ModalComponent, ContactMap, MassTimesCard } from 'components';
import ReactMarkdown from 'react-markdown';
import { GlobalType } from 'types/GlobalType';
import { HeaderNav } from './HeaderNav';

type MenuProps = {
  setIsMenuOpen: any;
  data: GlobalType;
};

const Menu: FC<MenuProps> = ({ setIsMenuOpen, data }) => {
  const massTimeData = data.strapiGlobal?.massTime;

  const massTimesHeadingData = {
    heading: '**Mass** Times',
  };
  const { strapiGlobal, allStrapiPage } = data;
  const headerLinks = strapiGlobal?.header?.headerLinks;
  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  const [isModal, setisModal] = useState(false);
  const handleModalOpen = () => {
    setIsMenuOpen(false);
    setisModal(true);
  };
  const closeModal = () => {
    setisModal(false);
  };

  return (
    <nav className="menu-wrapper">
      <div className="menu-details">
        <div className="menu-details-address">
          {data.strapiGlobal?.footer?.address?.data?.address}
        </div>
      </div>
      <HeaderNav
        headerLinks={headerLinks || []}
        allnodes={allStrapiPage?.nodes || []}
        handleNavClick={handleNavClick}
      />
      <button
        type="button"
        className="weekly-timings"
        onClick={() => {
          handleModalOpen();
        }}
      >
        <Calender />
        <span>{data.strapiGlobal?.header?.weeklyMassTimeTitle}</span>
      </button>
      <ModalComponent
        isModal={isModal}
        closesModal={closeModal}
        className="mass-timing-modal"
      >
        <div className="mass-timings">
          <h3 className="mass-timings-title">
            <ReactMarkdown>{massTimesHeadingData.heading}</ReactMarkdown>
          </h3>

          <MassTimesCard
            massTimeData={{
              dayTitle: massTimeData?.dayTitle ?? '',
              timeTitle: massTimeData?.timeTitle ?? '',
              SundayMassTimings: (massTimeData?.SundayMassTimings ?? []).map(
                item => ({
                  day: item.day ?? '',
                  time: item.time ?? '',
                })
              ),
              DailyMassTimings: (massTimeData?.DailyMassTimings ?? []).map(
                item => ({
                  day: item.day ?? '',
                  time: item.time ?? '',
                  note: item.note ?? '',
                })
              ),
            }}
          />
          {massTimeData?.note?.data?.note && (
            <ReactMarkdown>{massTimeData.note.data.note}</ReactMarkdown>
          )}
        </div>
        <ContactMap />
      </ModalComponent>
    </nav>
  );
};
export { Menu };
